import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "addonview" }
const _hoisted_2 = { class: "leftcontent flex" }
const _hoisted_3 = {
  key: 0,
  class: "bigbox flex v-center center"
}
const _hoisted_4 = {
  key: 1,
  class: "activitybox flex column"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex column grow-1 left-pad" }
const _hoisted_7 = { class: "flex gap" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = {
  key: 0,
  class: "description cost"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "button-box" }
const _hoisted_13 = { class: "info roundbox" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "img"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "rightcontent" }
const _hoisted_18 = {
  key: 0,
  class: "modal"
}
const _hoisted_19 = { class: "modalbox" }
const _hoisted_20 = { class: "bar flex gap stretch" }
const _hoisted_21 = { class: "grow-1 variant-title flex center" }
const _hoisted_22 = { class: "variant-list" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "name grow-1 flex-col" }
const _hoisted_25 = { class: "cost" }
const _hoisted_26 = { class: "flex column" }
const _hoisted_27 = {
  key: 1,
  class: "modal"
}
const _hoisted_28 = { class: "modalbox" }
const _hoisted_29 = { class: "bar flex gap stretch v-center" }
const _hoisted_30 = { class: "grow-1 variant-title flex center" }
const _hoisted_31 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_activity_selector = _resolveComponent("activity-selector")!
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_currency = _resolveComponent("currency")!
  const _component_quantity_ticker = _resolveComponent("quantity-ticker")!
  const _component_si_currency = _resolveComponent("si-currency")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_activity_selector, {
      validate: "addon",
      onOnChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activity?.getActivityOptions()))
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { package: _ctx.isPackage }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.activity?.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_loader_display)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addons, (addon) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["ratebox flex v-center", { selected: _ctx.isSelected(addon) }]),
                  key: addon.ProductKey ?? 0,
                  onClick: _withModifiers(($event: any) => (_ctx.select(addon)), ["stop"])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(addon.AddOnName), 1)
                    ]),
                    (!addon.Variants.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (addon.AddOnDiscount)
                            ? (_openBlock(), _createBlock(_component_currency, {
                                key: 0,
                                class: "strikethrough",
                                amount: addon.Cost
                              }, null, 8, ["amount"]))
                            : _createCommentVNode("", true),
                          _cache[7] || (_cache[7] = _createTextVNode()),
                          _createVNode(_component_currency, {
                            amount: _ctx.cost(addon)
                          }, null, 8, ["amount"])
                        ]))
                      : _createCommentVNode("", true),
                    (addon.Variants.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Select Options"))
                      : (!addon.IsBoolean)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_quantity_ticker, {
                              modelValue: addon.Quantity,
                              min: addon.AddOnIsRequired ? 1 : 0,
                              max: addon.MaxQuantity,
                              "onUpdate:modelValue": ($event: any) => (addon.Quantity = $event)
                            }, null, 8, ["modelValue", "min", "max", "onUpdate:modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: "gg-info small-icon white-shadow",
                        onClick: _withModifiers(($event: any) => (_ctx.infoModal = addon), ["stop"])
                      }, null, 8, _hoisted_14)
                    ])
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "check roundbox" }, [
                    _createElementVNode("div", { class: "gg-check-o small-icon white-shadow" })
                  ], -1)),
                  (_ctx.getThumb(addon))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: _ctx.getThumb(addon) ?? ''
                        }, null, 8, _hoisted_16)
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_5))
              }), 128))
            ]))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: _normalizeClass(["bookbutton", { broken: !_ctx.canProceed }]),
          onTouchstart: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"])),
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"]))
        }, _cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "gg-arrow-right-o" }, null, -1),
          _createElementVNode("div", null, "NEXT", -1)
        ]), 34)
      ])
    ], 2),
    (_ctx.variantModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                class: "close flex center v-center",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.variantModal = null))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("div", { class: "gg-close" }, null, -1)
              ])),
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.variantModal.AddOnName), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variantModal.Variants, (variant) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "variant flex v-center",
                  key: variant.ProductKey ?? 'product',
                  onClick: ($event: any) => (_ctx.select(variant))
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", null, _toDisplayString(variant.ProductName), 1),
                    _createElementVNode("div", _hoisted_25, [
                      (variant.AddOnDiscount)
                        ? (_openBlock(), _createBlock(_component_si_currency, {
                            key: 0,
                            class: "strikethrough",
                            amount: variant.Cost
                          }, null, 8, ["amount"]))
                        : _createCommentVNode("", true),
                      _cache[11] || (_cache[11] = _createTextVNode()),
                      _createVNode(_component_si_currency, {
                        amount: _ctx.cost(variant)
                      }, null, 8, ["amount"]),
                      _cache[12] || (_cache[12] = _createTextVNode("/ea", -1))
                    ])
                  ]),
                  (!variant.IsBoolean)
                    ? (_openBlock(), _createBlock(_component_quantity_ticker, {
                        key: 0,
                        min: variant.AddOnIsRequired ? 1 : 0,
                        max: variant.MaxQuantity,
                        modelValue: variant.Quantity,
                        "onUpdate:modelValue": ($event: any) => (variant.Quantity = $event)
                      }, null, 8, ["min", "max", "modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_23))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.commitVariants && _ctx.commitVariants(...args)), ["prevent"]))
              }, "Done")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.infoModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                class: "close flex center v-center",
                onTouchstart: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.infoModal = null), ["prevent"])),
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.infoModal = null), ["prevent"]))
              }, _cache[13] || (_cache[13] = [
                _createElementVNode("div", { class: "gg-close" }, null, -1)
              ]), 32),
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.modalTitle?.substring(0, 35)), 1)
            ]),
            _createElementVNode("div", {
              class: "pad",
              innerHTML: _ctx.infoModal.AddOnDescription
            }, null, 8, _hoisted_31)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}